import type { AxiosInstance } from "axios";
import { API_CONFIG } from "./constants";
import type { TApiBaseUrlOverrides } from "./types";
import { recreateApiInstance } from "./utils/apiFactory";
import { getUrlFromEnv } from "./utils/getUrlFromEnv";
import { initApi } from "./utils/initApi";

export let appAudioTranscriptionApi: AxiosInstance = initApi(
  API_CONFIG.audioTranscription.envUrl,
);
export let appAiScoringApi: AxiosInstance = initApi(
  API_CONFIG.aiScoring.envUrl,
);
export let appBaseUrl: AxiosInstance = initApi(API_CONFIG.baseUrl.envUrl);
export let appBotApi: AxiosInstance = initApi(API_CONFIG.bot.envUrl);
export let appClassificatorToolsApi: AxiosInstance = initApi(
  API_CONFIG.classificator.envUrl,
);
export let appDeepSearchApi: AxiosInstance = initApi(
  API_CONFIG.deepsearch.envUrl,
);
export let appDeerflowApi: AxiosInstance = initApi(API_CONFIG.deerflow.envUrl);
export let appGeneratePromptApi: AxiosInstance = initApi(
  API_CONFIG.generatePrompt.envUrl,
);
export let appModelsApi: AxiosInstance = initApi(API_CONFIG.model.envUrl);
export let appResponseApi: AxiosInstance = initApi(API_CONFIG.response.envUrl);
export let appSkillsApi: AxiosInstance = initApi(API_CONFIG.skills.envUrl);
export let appStaticKeyApi: AxiosInstance = initApi(
  API_CONFIG.staticKey.envUrl,
);
export let appStorageApi: AxiosInstance = initApi(API_CONFIG.storage.envUrl);
export let appTelegramApi: AxiosInstance = initApi(API_CONFIG.telegram.envUrl);
export let appThreadApi: AxiosInstance = initApi(API_CONFIG.thread.envUrl);
export let appVectorStoresApi: AxiosInstance = initApi(
  API_CONFIG.vectorstores.envUrl,
);
export let appVectorToolsApi: AxiosInstance = initApi(
  API_CONFIG.vectorTools.envUrl,
);

export const recreateAllApis = (
  setUserInfo: () => void,
  replacementToken: boolean = false,
  baseUrlOverrides: TApiBaseUrlOverrides = {},
) => {
  appAudioTranscriptionApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.audioTranscription.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.audioTranscription ||
      getUrlFromEnv(API_CONFIG.audioTranscription.envUrl),
  });

  appAiScoringApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.aiScoring.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.aiScoring || getUrlFromEnv(API_CONFIG.aiScoring.envUrl),
  });

  appBaseUrl = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.baseUrl.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.baseUrl || getUrlFromEnv(API_CONFIG.baseUrl.envUrl),
  });

  appBotApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.bot.replacement_token ?? replacementToken,
    baseUrl: baseUrlOverrides.bot || getUrlFromEnv(API_CONFIG.bot.envUrl),
  });

  appClassificatorToolsApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.classificator.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.classificator ||
      getUrlFromEnv(API_CONFIG.classificator.envUrl),
  });
  appDeepSearchApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.deepsearch.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.deepsearch ||
      getUrlFromEnv(API_CONFIG.deepsearch.envUrl),
  });
  appDeerflowApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.deerflow.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.deerflow || getUrlFromEnv(API_CONFIG.deerflow.envUrl),
  });
  appGeneratePromptApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.generatePrompt.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.generatePrompt ||
      getUrlFromEnv(API_CONFIG.generatePrompt.envUrl),
  });
  appModelsApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.model.replacement_token ?? replacementToken,
    baseUrl: baseUrlOverrides.model || getUrlFromEnv(API_CONFIG.model.envUrl),
  });
  appResponseApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.response.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.response || getUrlFromEnv(API_CONFIG.response.envUrl),
  });
  appSkillsApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.skills.replacement_token ?? replacementToken,
    baseUrl: baseUrlOverrides.skills || getUrlFromEnv(API_CONFIG.skills.envUrl),
  });
  appStaticKeyApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.staticKey.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.staticKey || getUrlFromEnv(API_CONFIG.staticKey.envUrl),
  });
  appStorageApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.storage.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.storage || getUrlFromEnv(API_CONFIG.storage.envUrl),
  });
  appThreadApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.thread.replacement_token ?? replacementToken,
    baseUrl: baseUrlOverrides.thread || getUrlFromEnv(API_CONFIG.thread.envUrl),
    skipLogoutOn401: true,
  });
  appTelegramApi = recreateApiInstance({
    setUserInfo,
    replacementToken: API_CONFIG.telegram.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.telegram || getUrlFromEnv(API_CONFIG.telegram.envUrl),
    skipLogoutOn401: true,
  });
  appVectorStoresApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.vectorstores.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.vectorstores ||
      getUrlFromEnv(API_CONFIG.vectorstores.envUrl),
  });
  appVectorToolsApi = recreateApiInstance({
    setUserInfo,
    replacementToken:
      API_CONFIG.vectorTools.replacement_token ?? replacementToken,
    baseUrl:
      baseUrlOverrides.vectorTools ||
      getUrlFromEnv(API_CONFIG.vectorTools.envUrl),
  });
};
